module.exports = __webpack_public_path__ + "assets/fc9243e7589b0478175dc9aaebf80c2b.svg";